<template>
  <div class="subpage__body">
    <section>
      <h2>I work as a Full Stack Developer</h2>
      <p class="about">
        <img src="@/assets/rebecka.png" alt="a photo of Rebecka looking sharp in a sidecut and a black shirt"
          class="rebecka_portrait">    
        <span>...and have a degree from <a href="https://medieinstitutet.se/utbildningar/front-end-developer/"
          target="_new">Medieinstitutet</a>.
        I enjoy both problem solving and design.
        I also have a degree in biology and have previously worked identifying trees, whales and counterfeit
        passports.</span>     
      </p>
    </section>
  </div>
</template>